import { ArbreService } from './arbre.service';
import { AuthService } from './auth.service';
import { BevaService } from './beva.service';
import { ChampignonService } from './champignon.service';
import { ContactService } from './contact.service';
import { DroitService } from './droit.service';
import { EpaysageService } from './epaysage.service';
import { EpaysageInventoryService } from './epaysage-inventory.service';
import { EspeceService } from './espece.service';
import { EssenceService } from './essence.service';
import { ForfaitService } from './forfait.service';
import { GroupeService } from './groupe.service';
import { HistoryService } from './history.service';
import { InventoryService } from "./inventory.service";
import { NuisibleService } from './nuisible.service';
import { PlantationService } from './plantation.service';
import { ProfilService } from './profil.service';
import { settingsService } from './settings.service';
import { SmsService } from './sms.service';
import { subscriptionService } from './subscription.service';
import { TravauxService } from './travaux.service';
import { UserSettingsService } from './user-settings.service';
import { UserService } from './user.service';
export const services = {
  inventory: new InventoryService(),
  arbre: new ArbreService(),
  auth: new AuthService(),
  user: new UserService(),
  userSettings: new UserSettingsService(),
  profil: new ProfilService(),
  groupe: new GroupeService(),
  droit: new DroitService(),
  forfait: new ForfaitService(),
  espece: new EspeceService(),
  epaysage: new EpaysageService(),
  epaysageInventory: new EpaysageInventoryService(),
  essence: new EssenceService(),
  champignon: new ChampignonService(),
  nuisible: new NuisibleService(),
  plantation: new PlantationService(),
  history: new HistoryService(),
  beva: new BevaService(),
  travaux: new TravauxService(),
  contact: new ContactService(),
  subscription: subscriptionService,
  settings: settingsService,
  sms: new SmsService(),
} as const;